module.exports = __webpack_public_path__ + "img/no-search.fbaf7eeb.svg";